
const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/im
const PHONE_REGEX = /1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/

export default {
  /**
   * Users regexp to check if there is email-like text in the string
   * @param content
   */
  containsEmail: content => content.search(EMAIL_REGEX) !== -1,

  /**
   * Users regexp to check if there is a phone number in the string
   * @param content
   */
  containsPhoneNumber: content => content.search(PHONE_REGEX) !== -1
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/validation-utils.ts